import { ExitToApp } from '@mui/icons-material';
import DrowDownArrowIcon from '@mui/icons-material/ArrowDropDownRounded';
import {
  Button, ButtonBase, Fade, Menu, MenuItem,
} from '@mui/material';
import clsx from 'clsx';
import React from 'react';
import { CommandContextFieldsFragment, useGetLiveProjectQuery } from '../../../../../generated/core-api/graphql-react-query';
import useLiveContext from '../../../../LiveContext/useLiveContext';
import StyledBox from './styles';

export default function ContextSelector() {
  const { sessionState: { context, changeContext }, projectId } = useLiveContext();
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const contexts = useGetLiveProjectQuery({ input: { id: projectId ?? '' } }, { enabled: !!projectId });

  const contextMap = React.useMemo(() => {
    const map = new Map<string, CommandContextFieldsFragment>();
    contexts.data?.getProject.commandContexts.forEach((value) => {
      map.set(value.textLower, value);
    });
    return map;
  }, [contexts.data]);

  return (
    <Fade in={!!context} mountOnEnter unmountOnExit>
      <StyledBox>
        <ButtonBase
          className={clsx('select', { expand: !!anchorEl })}
          onClick={(e) => { setAnchorEl(e.currentTarget); }}
        >
          {contextMap.get(context ?? '')?.text}
          <DrowDownArrowIcon />
        </ButtonBase>
        <Button className="exit" onClick={() => { changeContext(null); }} variant="text">
          <ExitToApp />
        </Button>
        <Menu
          anchorEl={anchorEl}
          open={!!anchorEl}
          onClose={() => { setAnchorEl(null); }}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'left',
          }}
          transformOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}
        >
          {contexts.data?.getProject.commandContexts.map((value) => (
            <MenuItem
              key={value.textLower}
              onClick={() => {
                changeContext(value.textLower);
                setAnchorEl(null);
              }}
            >
              {value.text}
            </MenuItem>
          ))}
        </Menu>
      </StyledBox>
    </Fade>
  );
}
